import { type ReactNode } from 'react';
import { Section } from '~/shared/section/Section';
import { SectionHeader, type SectionHeaderProps } from '~/shared/section/SectionHeader';
import { type ButtonProps } from '../../components/buttons/Button';
import { SectionListContextProvider } from './SectionListContext';

export type SectionButtonProps = Omit<ButtonProps, 'renderModal' | 'label'> & {
	label: string;
	renderModal: (closeModal: () => void) => ReactNode;
};

export interface SectionListProps extends SectionHeaderProps {
	items: ReactNode[];
	canEdit?: boolean;
}

export function SectionList({ items, canEdit = false, ...props }: SectionListProps) {
	return (
		<SectionListContextProvider canEdit={canEdit}>
			<Section header={<SectionHeader {...props} sectionButtonProps={canEdit ? props.sectionButtonProps : undefined} />}>
				{items.length > 0 ? <div className="space-y-4">{items}</div> : <div className="text-sm text-gray-500">No items found.</div>}
			</Section>
		</SectionListContextProvider>
	);
}
